import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import styles from './SelectElement.pcss';

class SelectElement extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        children: PropTypes.object,
        className: PropTypes.string,
        getValue: PropTypes.func,
        onChange: PropTypes.func,
        //setValue: PropTypes.func,
        showError: PropTypes.func,
        isPristine: PropTypes.func,
        getErrorMessage: PropTypes.func,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        disabled: false
    };

    onClick = event => {
        if (this.props.onChange && !this.props.disabled) {
            const value = this.props.getValue();
            this.props.onChange(event, this.props.name, value);
        }
    };

    render() {
        const {
            name,
            children,
            className,
            getValue,
            isPristine,
            showError,
            getErrorMessage,
            disabled
        } = this.props;

        const isError = !isPristine() && showError();

        const wrapperClasses = cx(styles.wrapper, className, {
            [styles.disabled]: disabled,
            [styles.selected]: !!getValue()
        });

        return (
            <div className={wrapperClasses} name={name} role="presentation" onClick={this.onClick}>
                <div className={styles.container}>{children}</div>
                {isError && <div className={styles.error}>{getErrorMessage()}</div>}
            </div>
        );
    }
}

export default withFormsy(SelectElement);
